export default {
  exampleState: state => state.exampleState,
  example2Staff: state => {
    return state.example2Staff && state.example2Staff;
  },
  userState: state => state.userState,
  loginErrorState: state => state.loginErrorState,
  registrationErrorState: state => state.registrationErrorState,
  pendingOrdersState: state => state.pendingOrdersState,
  dashboardStatisticalDataState: state => state.dashboardStatisticalDataState,
  customerFilterState: state => state.customerFilterState,
  companyFilterState: state => state.companyFilterState,
  statusFilterState: state => state.statusFilterState,
  fromDateFilterState: state => state.fromDateFilterState,
  toDateFilterState: state => state.toDateFilterState,
  customerState: state => state.customerState,
  customerOrdersState: state => state.customerOrdersState,
  planState: state => state.planState,
  planConstraintsState: state => state.planConstraintsState,
  accountDetailsState: state => state.accountDetailsState,
  getGlobalLoader: state => state.globalLoader,
  isCurrentPlanBasic: state => state.userState.currentPlan.slug == "basic",
  isCurrentPlanEnterprise: state => state.userState.currentPlan.slug == "enterprise",
  isCurrentPlanSmb: state => state.userState.currentPlan.slug == "smb",
  orderLimitExhaustedNotification: state => state.orderLimitExhaustedNotification
};

// usage of getters: this.$store.getters.happyStaff
